import { Navigate, Outlet } from "react-router";
import { useAuthStore } from "../store/useAuthStore.js";

export function ProtectedRoute() {
  const token = useAuthStore((state) => state.token);

  // If no token, redirect to login page
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render child routes
  return <Outlet />;
}
